import { render } from "./PropLine.vue?vue&type=template&id=3a083a87"
import script from "./PropLine.vue?vue&type=script&lang=js"
export * from "./PropLine.vue?vue&type=script&lang=js"
script.render = render

export default script